module.exports = __webpack_public_path__ + "static/media/LD_RL_CHICA.b66ef877.webp";